import { FormikForm } from '../../../Formik'
import { DocFlowWidgetFormContent } from '../DocFlowWidgetFormContent'

function DocFlowWidgetForm(props) {
  return (
    <FormikForm
      {...props}
      enableReinitialize
      validateOnBlur={false}
      validateOnChange={false}
    >
      <DocFlowWidgetFormContent {...props} />
    </FormikForm>
  )
}

export default DocFlowWidgetForm
